import React from "react";
import { FormControl, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import type { OperandDto } from "../../../../../../types/resolver";
import { WORK_ITEM_ATTRIBUTE_NAMES, OTHER_KEY } from "./constants";
import type { OperandTypeComponentProps } from "./types";

export const WorkItemAttributeOperand: React.FC<OperandTypeComponentProps> = ({
    value,
    onChange,
}) => {
    const currentName = value?.workItemAttributeName ?? "";
    const isKnown = currentName && (WORK_ITEM_ATTRIBUTE_NAMES as readonly string[]).includes(currentName);

    return (
        <>
            <FormControl size="small" fullWidth>
                <InputLabel id="work-item-attr-label">Work item attribute</InputLabel>
                <Select
                    labelId="work-item-attr-label"
                    label="Work item attribute"
                    value={isKnown ? currentName : OTHER_KEY}
                    onChange={(e) => {
                        const v = e.target.value as string;
                        onChange({
                            ...(value ?? {}),
                            operandType: "workItemAttribute",
                            workItemAttributeName: v === OTHER_KEY ? "" : v,
                        } as OperandDto);
                    }}
                >
                    {WORK_ITEM_ATTRIBUTE_NAMES.map((name) => (
                        <MenuItem key={name} value={name}>
                            {name}
                        </MenuItem>
                    ))}
                    <MenuItem value={OTHER_KEY}>
                        <em>Other (type below)</em>
                    </MenuItem>
                </Select>
            </FormControl>
            {!isKnown && (
                <TextField
                    size="small"
                    label="Custom work item attribute name"
                    value={currentName}
                    onChange={(e) =>
                        onChange({
                            ...(value ?? {}),
                            operandType: "workItemAttribute",
                            workItemAttributeName: e.target.value,
                        } as OperandDto)
                    }
                    placeholder="e.g. patientClass"
                    fullWidth
                />
            )}
        </>
    );
};
